<button mat-raised-button [color]="color" [disabled]="disabled" [type]="buttonType" (click)="buttonClicked()">
  <mat-icon *ngIf="icon">{{ icon }}</mat-icon>
  <mat-icon *ngIf="svgIcon" [svgIcon]="svgIcon"></mat-icon>
  <span *ngIf="label" class="button-label">{{ label }}</span>
</button>
